<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 12 12"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#FFF" fill-rule="nonzero">
        <g>
          <path
            d="M10.302 2.281L3.996 8.583 1.698 6.287c-.393-.38-1.018-.374-1.405.012-.386.386-.391 1.01-.012 1.404l3.006 3.004c.392.39 1.026.39 1.417 0l7.015-7.01c.38-.393.374-1.017-.012-1.404-.387-.386-1.012-.391-1.405-.012z"
            transform="translate(-4 -4) translate(4 4)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'TickIcon',
  props: {
    height: VueTypes.string.def('12'),
    width: VueTypes.string.def('12'),
  },
};
</script>

<style lang="scss"></style>
